<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <div>
          <div class="side-card mb-2 mt-2 mt-md-0">
            <div class="d-flex justify-content-between">
              <p class="fs-17 font-weight-bold mb-4 ml-1" style="line-height: 0.675rem; color: #163D7D;">Detalles del ticket</p>
              <b-button v-if="canEditDetails" variant="outline-light" size="sm" @click="openDetailsModal('all')">
                <font-awesome-icon  :icon="['far', 'edit']" class="text-warning" size="lg" fixed-width />
              </b-button>
            </div>
            <table
              class="table table-borderless table-sm table-details"
            >
              <tbody>
                <tr v-if="isDev">
                  <th>SAP:</th>
                  <td>
                    <span v-if="ticket.sap_is_synced">
                      <font-awesome-icon :icon="['fas', 'dot-circle']" fixed-width class="text-success" />
                    </span>
                    <span v-else>
                      <font-awesome-icon :icon="['fas', 'dot-circle']" fixed-width class="text-danger" />
                    </span>
                  </td>
                </tr>
                <tr>
                  <th>Estado:</th>
                  <td>
                    <b-badge v-if="ticket.status" class="fs-12" pill :variant="badgeStatusMap[ticket.status].variant || 'info'" style="font-size: 90%">
                      {{badgeStatusMap[ticket.status].text || ticket.status}}
                    </b-badge>
                  </td>
                </tr>
                <tr>
                  <th>Departamento:</th>
                  <td>
                    <span v-if="ticket.internal_ticket_level">{{ ticket.internal_ticket_level.department }}</span>
                  </td>
                </tr>
                <tr>
                  <th>Tipo solicitud:</th>
                  <td>
                    <span v-if="ticket.internal_ticket_level">{{ ticket.internal_ticket_level.request_type }}</span>
                  </td>
                </tr>
                <tr>
                  <th>Requerimiento:</th>
                  <td>
                    <span v-if="ticket.internal_ticket_level">{{ ticket.internal_ticket_level.requirement }}</span>
                  </td>
                </tr>
                <tr>
                  <th>Creado:</th>
                  <td>{{  ticket.created_at | formatDateTime }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="side-card mb-2">
            <p class="fs-17 font-weight-bold mb-4 " style="line-height: 0.675rem; color: #163D7D;">Responsabilidad</p>
            <div class="d-flex justify-content-between mb-2">
              <p class="darkgrey-title fs-15 mb-0">Solicitado por</p>
            </div>
            <div class="mb-3">
              <NameInitialsIcon :user="ticket.user ? ticket.user : {}" color="#163D7D" />
            </div>
            <div class="d-flex justify-content-between mb-2">
              <p class="darkgrey-title fs-15 mb-0">Agente</p>
              <b-link v-if="canEditDetails" @click="openDetailsModal('agent')" class="fs-15">Cambiar</b-link>
            </div>
            <div>
              <NameInitialsIcon :user="ticket.agent ? ticket.agent : {}" color="#ffa500" />
            </div>
            <div class="d-flex justify-content-between mb-2 mt-3">
              <p class="darkgrey-title fs-15 mb-0">Seguidores</p>
              <div v-if="canManageFollowers">
                <b-link @click="showFollowersModal = true" class="fs-15">
                  <p class="mb-0 d-flex align-items-center">
                    <font-awesome-icon :icon="['far', 'plus-circle']" fixed-width />
                    <span class="ml-1 mb-1">Agregar</span>
                  </p>
                </b-link>
              </div>
            </div>
            <div>
              <div v-if="followers.length > 0" class="d-flex align-items-center">
                <NameInitialsIcon :user="followers[0] ? followers[0] : {}" color="#8b8b9e" />
                <b-link @click="showFollowersModal = true" class="fs-15">
                  <p v-if="followers.length == 1" class="ml-2">
                    ver
                  </p>
                  <p v-else class="ml-2"> +{{ followers.length - 1}}</p>
                </b-link>
              </div>
              <p v-else class="text-secondary fs-17 mb-0 text-center font-italic">
                No hay seguidores para este ticket
              </p>
            </div>
          </div>
          <div class="side-card mb-2">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <p class="fs-17 font-weight-bold mb-0 ml-1" style="line-height: 0.675rem; color: #163D7D;">Anexos</p>
              <b-link v-if="canAddAttachments" @click="openAttachmentsModal" class="fs-15">Agregar anexo</b-link>
            </div>
            <div v-if="attachments.length > 0" class="ml-1 mt-4">
              <ol class="pl-1 mb-0" style="max-height: 250px; overflow-y: auto">
                <li v-for="file in attachments" :key="`${file.type}-${file.id}`" style="list-style: none; margin-bottom: 2px; padding-top: 4px;">
                  <div class="d-flex justify-content-between border-bottom align-items-center w-100">
                    <b-link
                      class="text-truncate"
                      @click="handleOnClickAttachment(file)"
                    >
                      <span v-if="file.type == 'document'">
                        <font-awesome-icon :icon="['far', 'file-alt']" fixed-width />
                        <span>{{ file.name }}</span>
                      </span>
                      <span v-else>
                        <font-awesome-icon :icon="['far', 'image']" fixed-width />
                        <span>{{ file.caption }}</span>
                      </span>
                    </b-link>
                    <p
                      class="text-muted mb-0 fs-13 ml-1 text-right"
                      style="line-height: 13px; white-space: nowrap;"
                    >
                      {{ file.created_at | formatDateTime }}
                    </p>
                  </div>
                </li>
              </ol>
            </div>
            <div v-else class="text-center ml-1">
              <p class="fs-17 text-secondary mt-3 mb-0 font-italic">No hay anexos aún</p>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>

    <!-- details modal -->
    <Modal
      v-if="showDetailModal"
      contentWidth="700px"
      :required=true
      @close="onCloseDetailsModal"
    >
      <template #header>
        <p class="fs-20 font-weight-bold ml-1 mb-0" style="line-height: 0.675rem; color: #163D7D;">
          {{ detailsModalTitle }}
        </p>
      </template>
      <template #body>
        <b-row>
          <b-col>
            <div v-if="modalMode == 'all'">
              <b-form-group id="input-group-1" class="mt-2 mb-2">
                <template #label>
                  <span class="mb-1 text-muted">Estado<span class="text-danger ml-1">*</span></span>
                </template>
                <b-form-select
                  id="input-1"
                  v-model="form.status"
                  :options="statusOptions"
                  :state="form.status ? true : false"
                >
                  <template #first>
                    <b-select-option :value="null">
                      <span class="text-danger">--- seleccione ---</span>
                    </b-select-option>
                  </template>
                </b-form-select>
              </b-form-group>

              <LevelSelector
                :ticketLevel="ticket.internal_ticket_level"
                @setInternalTicketLevel="setInternalTicketLevel"
              />
            </div>

            <div class="mt-2">
              <p class="mb-1 text-muted">Agente<span class="text-danger ml-1">*</span></p>

              <div v-if="selectedAgent" class="d-flex justify-content-between">
                <b-input-group>
                  <b-input
                    :value="`${selectedAgent.first_name} ${selectedAgent.last_name || ''} ${selectedAgent.last_name2 || ''}`"
                    disabled
                    :state="selectedAgent ? true : false"
                  />
                  <b-input-group-append>
                    <b-button variant="outline-secondary" @click="changeAgent">
                      Cambiar
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </div>
              <div v-else>
                <b-input-group>
                  <b-input
                    v-model="agentSearchTerm"
                    autofocus
                    placeholder="Buscar por nombre, apellido o correo"
                    ref="searchInput"
                    @keyup.enter="searchAgent"
                  />
                  <b-input-group-append>
                    <b-button variant="outline-secondary" :disabled="!agentSearchTerm" @click="searchAgent">
                      <font-awesome-icon :icon="['fas', 'search']" fixed-width />
                    </b-button>
                    <b-button
                      variant="outline-secondary"
                      size="sm"
                      class="ml-2"
                      :disabled="!agentSearchTerm"
                      @click="resetAgent"
                    >
                      <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width/>
                      <span class="pl-1">Limpiar</span>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

                <div style="max-height: 250px" class="overflow-auto mt-1">
                  <b-table
                    :items="agentSearchResults"
                    :fields="agentSearchFields"
                    outlined
                    show-empty
                    class="fs-14"
                    :tbody-tr-class="rowAgentClass"
                    @row-clicked="selectAgent"
                  >
                    <template #empty>
                      <div class="text-center">
                        <span v-if="searchingAgent" class="text-info">
                          <font-awesome-icon :icon="['fas', 'spinner']" pulse fixed-width />
                          <span class="pl-2">Buscando...</span>
                        </span>
                        <span v-else-if="agentSearchFailed" class="text-danger">
                          <span >Hubo un error al buscar, intente de nuevo</span>
                        </span>
                        <span v-else-if="agentSearchDone && !agentSearchResults.length" class="text-danger">
                          No hay resultados
                        </span>
                        <span v-else class="text-secondary">
                          Buscar por nombre, apellido o correo
                        </span>
                      </div>
                    </template>
                    <template #cell(name)="data">
                      <span>{{ data.item | concatName3 | titleize }}</span>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </template>
    <template #footer>
      <b-button variant="outline-danger" @click="showDetailModal = false">
        Cerrar
      </b-button>
      <b-button :disabled="invalidTicket" variant="outline-success" @click="updateDetails()">
        Actualizar
      </b-button>
    </template>
    </Modal>

    <!-- Followers Modal -->
    <Modal
      v-if="showFollowersModal"
      contentWidth="700px"
      :required=true
      @close="onCloseFollowersModal"
    >
      <template #header>
        <p class="fs-20 font-weight-bold ml-1 mb-0" style="line-height: 0.675rem; color: #163D7D;">
          Seguidores del ticket
        </p>
      </template>
      <template #body>
        <b-row v-if="canManageFollowers">
          <b-col>
            <b-form-group>
              <b-input-group style="width: 100%;">
                <b-input
                  v-model="searchFollowerTerm"
                  autofocus
                  placeholder="Buscar por nombre, apellido o correo"
                  @keydown.enter="searchFollower"
                />
                <b-input-group-append>
                  <b-button variant="outline-secondary" @click="searchFollower">
                    <font-awesome-icon v-if="searchingFollower" :icon="['fas', 'spinner']" pulse fixed-width />
                    <font-awesome-icon v-else :icon="['fas', 'search']" fixed-width />
                  </b-button>
                </b-input-group-append>
                <b-input-group-append class="ml-3">
                  <b-button variant="outline-secondary" @click="resetFollowerSearch">
                    <font-awesome-icon :icon="['far', 'undo-alt']" fixed-width />
                    <span class="pl-1">Limpiar</span>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div style="max-height: 350px" class="overflow-auto mt-1">
              <b-table
                :items="availableFollowers"
                :fields="followersFields"
                primary-key="id"
                outlined
                bordered
                small
                show-empty
                class="fs-15"
                :tbody-tr-class="rowFollowerClass"
              >
                <template #empty>
                  <div v-if="searchingFollower" class="text-center text-info">
                    <b-spinner small type="grow"></b-spinner>
                    <span class="pl-2">Cargando...</span>
                  </div>
                  <p v-else-if="searchFollowerEmpty" class="text-danger text-center pt-3">
                    No hay resultados
                  </p>
                  <p v-else class="text-muted text-center pt-3">
                    Ingrese un término de búsqueda
                  </p>
                </template>

                <template #cell(state)="data">
                  <template v-if="data.item.alreadyAdded">
                    <b-spinner v-if="processingFollower && data.item.id == selectedFollowerId" small type="grow" class="text-info"></b-spinner>
                    <font-awesome-icon
                      v-else
                      :icon="['fas', 'check-square']"
                      size="lg"
                      fixed-width
                      class="text-success"
                      :class="{ 'clickable': canManageFollowers }"
                      @click="removeFollower(data.item.id)"
                    />
                  </template>
                  <template v-else>
                    <b-spinner v-if="processingFollower && data.item.id == selectedFollowerId" small type="grow" class="text-info"></b-spinner>
                    <font-awesome-icon
                      v-else
                      :icon="['far', 'square']"
                      size="lg"
                      fixed-width
                      :class="{ 'clickable': canManageFollowers }"
                      @click="addFollower(data.item)"
                    />
                  </template>
                </template>
                <template #cell(name)="row">
                  <span>{{ row.item | concatName3 | titleize }}</span>
                </template>
              </b-table>
            </div>
          </b-col>
        </b-row>
      </template>
      <template #footer>
        <span></span>
      </template>
    </Modal>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { statusOptions } from '../../../sharedOptions/ticketsModule'

import Modal from '../../shared/Modal'
import LevelSelector from './LevelSelector'
import { badgeStatusMap } from '../../../sharedOptions/ticketsModule'
import NameInitialsIcon from '../../shared/NameInitialsIcon.vue'

export default {
  name: 'ShowAside',
  components: { NameInitialsIcon, Modal, LevelSelector },
  props: {
    ticket: {
      type: Object,
      required: true,
      default: () => {}
    },
    attachments: {
      type: Array,
      required: true,
      default: () => ([])
    },
    followers: {
      type: Array,
      required: true,
      default: () => ([])
    },
    canEditDetails: {
      type: Boolean,
      required: true,
      default: false
    },
    canAddAttachments: {
      type: Boolean,
      required: true,
      default: false
    },
    canManageFollowers: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data () {
    return {
      processing: false,
      badgeStatusMap: badgeStatusMap,
      showDetailModal: false,
      modalMode: 'all',
      statusOptions: statusOptions,
      agentSearchTerm: '',
      agentSearchDone: false,
      agentSearchFailed: false,
      searchingAgent: false,
      selectedAgent: null,
      agentSearchResults: [],
      tabIndex: 0,
      agentSearchFields: [
        { key: 'name', label: 'Nombre', tdClass: '', thClass: 'text-muted font-lato' },
        { key: 'email', label: 'Correo', tdClass: '', thClass: 'text-muted font-lato', thStyle: { width: '240px' } },
      ],
      form: {
        status: null,
        internal_ticket_level_id: null,
        agent_id: null
      },
      showFollowersModal: false,
      searchFollowerTerm: '',
      searchFollowerEmpty: false,
      searchingFollower: false,
      processingFollower: false,
      resultFollowers: [],
      selectedFollowerId: null,
      followersFields: [
        { key: 'state', label: '', tdClass: 'align-middle text-center', thClass: 'text-center', thStyle: { width: '36px' }},
        { key: 'name', label: 'Nombre', tdClass: 'align-middle', thClass: 'text-muted font-lato', thStyle: { width: '340px' } },
        { key: 'email', label: 'Correo', tdClass: 'align-middle d-none d-md-block', thClass: 'text-muted font-lato d-none d-md-block' },
      ]
    }
  },
  computed: {
    ...mapGetters(['isDev']),
    ...mapState({
      currentUser: state => state.currentUser
    }),
    invalidTicket () {
      if (this.modalMode == 'all') {
        if (!this.form.status || !this.form.internal_ticket_level_id || !this.form.agent_id) return true
      } else if (this.modalMode == 'agent') {
        if (!this.form.agent_id) return true
      }

      return false
    },
    detailsModalTitle () {
      return this.modalMode == 'all' ? 'Detalles del ticket' : 'Cambiar agente'
    },
    availableFollowers () {
      if (this.resultFollowers.length > 0) {
        const followerIds = this.followers.map(follower => follower.id)

        return this.resultFollowers.map(follower => ({...follower, alreadyAdded: followerIds.includes(follower.id)}))
      }

      if (this.searchFollowerTerm && this.searchFollowerEmpty) return []

      return this.followers.map(follower => ({...follower, alreadyAdded: true }))
    }
  },
  methods: {
    openDetailsModal (modalMode) {
      this.modalMode = modalMode
      this.form.status = this.ticket.status
      this.form.internal_ticket_level_id = this.ticket.internal_ticket_level_id
      this.form.agent_id = this.ticket.agent_id
      this.selectedAgent = this.ticket.agent
      this.showDetailModal = true
    },
    onCloseDetailsModal () {
      this.form.status = null
      this.form.internal_ticket_level_id = null
      this.form.agent_id = null
      this.modalMode = 'all'
      this.resetAgent()
      this.showDetailModal = false
    },
    updateDetails () {
      const dataToUpdate = this.modalMode == 'all' ? this.form : { agent_id: this.form.agent_id }
      if (this.modalMode == 'agent' && this.ticket.agent_id === dataToUpdate.agent_id) {
        this.onCloseDetailsModal()
        return
      }
      this.$emit('updateTicket', dataToUpdate)
      this.onCloseDetailsModal()
    },
    setInternalTicketLevel (level_id) {
      this.form.internal_ticket_level_id = level_id
    },
    searchAgent (onIndex = false) {
      if (!this.agentSearchTerm && !onIndex) return
      if (this.searchingAgent) return
      const term = this.normalizeString(this.agentSearchTerm)
      this.searchingAgent = true
      this.agentSearchFailed = false
      this.agentSearchDone = false
      this.$http.get('/api/production/internal_tickets/search_agents', {
          params: { q: term }
        })
        .then(response => {
          // console.log(response.data)
          this.agentSearchResults = response.data
          this.agentSearchDone = true
        })
        .catch(error => {
          this.agentSearchFailed = true
          this.agentSearchResults = []
          console.log(error)
        })
        .finally(()=> {
          this.searchingAgent = false
        })
    },
    selectAgent (agent) {
      if (agent.id === this.ticket.agent_id) return

      this.selectedAgent = agent
      this.form.agent_id = agent.id
    },
    resetAgent () {
      this.selectedAgent = null
      this.form.agent_id = null
      this.agentSearchTerm = ''
      this.agentSearchDone = false
      this.agentSearchResults = []
    },
    changeAgent () {
      this.resetAgent()
      // this.searchAgent(true)
    },
    rowAgentClass (item) {
      if (!item) return

      if (item.id === this.ticket.agent_id) {
        return 'table-row-muted'
      }

      return 'clickable'
    },
    openAttachmentsModal () {
      this.$emit('toggle-attachments-modal')
    },
    handleOnClickAttachment (file) {
      if (this.processing) { return }
      this.processing = true

      if (file.type == 'photo') {
        this.$http.get(`/api/production/internal_tickets/${this.ticket.id}/photos/${file.id}`)
          .then((resp) => {
            this.$emit('showFullImage', resp.data.presigned_url)
          })
          .catch(e => console.log(e))
          .finally(() => this.processing = false)
      } else {
        this.$http.get(`/api/production/internal_tickets/${this.ticket.id}/documents/${file.id}/download`)
          .then((resp) => {
            const url = resp.data
            const link = document.createElement('a')
            link.href = url
            link.download = file.name
            document.body.appendChild(link)
            link.click()
            link.remove()
          })
          .catch(e => console.log(e))
          .finally(this.processing = false)
      }
    },
    onCloseFollowersModal () {
      this.searchFollowerTerm = ''
      this.resultFollowers = []
      this.showFollowersModal = false
      this.searchFollowerEmpty = false
      this.selectedFollowerId = null
      this.processingFollower = false
    },
    searchFollower () {
      if (!this.searchFollowerTerm.length) {
        this.resultFollowers = []
        this.searchFollowerEmpty = false
        return
      }
      if (this.searchingFollower) { return }
      const term = this.normalizeString(this.searchFollowerTerm)
      this.searchingFollower = true
      this.$http.get(`/api/production/internal_ticket_followers/search`, {
          params: {
            q: term
          }
        })
        .then(response => {
          // console.log(response)
          this.resultFollowers = response.data
          this.searchFollowerEmpty = this.resultFollowers.length === 0
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => {
          this.searchingFollower = false
        })
    },
    rowFollowerClass (item) {
      if (!item) return
      if (this.resultFollowers.length === 0) return ''

      if (item.id === this.ticket.user_id) {
        return 'table-row-muted'
      }

      return ''
    },
    addFollower (userToAdd) {
      if (!this.canManageFollowers) return
      if (userToAdd.id === this.ticket.user_id) return

      if (this.processingFollower) return
      this.processingFollower = true
      this.selectedFollowerId = userToAdd.id
      this.$http.post(`/api/production/internal_tickets/${this.ticket.id}/followers`, {
        follower: {
          user_id: userToAdd.id
        }
      })
        .then(response => {
          this.$emit('add-follower', response.data)
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => {
          setTimeout(() => {
            this.processingFollower = false
            this.selectedFollowerId = null
          }, 500)
        })
    },
    removeFollower (userId) {
      if (!this.canManageFollowers) return

      if (this.processingFollower) return
      this.processingFollower = true
      this.selectedFollowerId = userId
      this.$http.delete(`/api/production/internal_tickets/${this.ticket.id}/followers/${userId}`)
        .then(response => {
          this.$emit('remove-follower', userId)
        })
        .catch(error => {
          // console.log(error)
        })
        .finally(() => {
          setTimeout(() => {
            this.processingFollower = false
            this.selectedFollowerId = null
          }, 500)
        })
    },
    resetFollowerSearch () {
      this.searchFollowerTerm = ''
      this.resultFollowers = []
      this.searchFollowerEmpty = false
      this.selectedFollowerId = null
    },
    normalizeString (str) {
      return str?.toString()
                  .toLowerCase()
                  .trim()
                  .replace(/\s+/g, " ") // replace multiple spaces with one
                  .replace(/[áÁ]/g, 'a')
                  .replace(/[éÉ]/g, 'e')
                  .replace(/[íÍ]/g, 'i')
                  .replace(/[óÓ]/g, 'o')
                  .replace(/[úÚ]/g, 'u')
    }
  }
}
</script>


<style scoped lang="scss">
  .table-details {
    margin-bottom: 0px;
    font-size: 15px;
    th:first-child {
      width: 110px;
    }
    th {
      font-weight: 450;
      color: #868c91;
    }
    td {
      font-weight: 600;
      color: #888e97;
    }
  }

  .darkgrey-title {
      font-weight: 500;
      color: #868c91;
  }

  .side-card {
    padding: 1rem;
    border-radius: 0.7rem;
    overflow: hidden;
    border: 2px solid #e2e8f0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }

  .sticky-section {
    position: sticky;
    top: 0;
    z-index: 10;
  }

</style>